import React from 'react'
import Footer from '../Components/Footer'
import LoginComp from '../Components/LoginComp'
const Login = () => {
  return (
    <div>
      <LoginComp/>
      <Footer/>
    </div>
  )
}

export default Login